// 2020-05-12 岳总需要的演示版本

const toast = require('../component/toast');

const appendFileItemToList = (name) => {
  const listDOMPath = '.allowance-content .header-operation .content .form-sheet form .file-list';
  const fileItemDOM = '<div class="file-row">' +
    '<img class="icon" src="static/image/demo/file-icon.png" />' +
    '<div>' + name + '</div>' +
    '<img class="status-flag" src="static/image/demo/check-radus-green.png" />' +
    '</div>';
  $(listDOMPath).append(fileItemDOM);
};

// button click event
/**
 * 专家咨询
 */
const onClickedCommitAdvice = () => {
  $('.expert-advice-content .header-operation .form-sheet input').each(function () {
    $(this).val('')
  });

  $('.expert-advice-content .header-operation .form-sheet textarea').each(function () {
    $(this).val('')
  });

  toast.showToast('保存成功');
};
/**
 * 保险服务
 */
const onClickedCommitClaim = () => {
  const btnAgreement = $('.claim-content .header-operation .form-sheet .row .check-btn .icon-selected');
  if (!btnAgreement || btnAgreement.length === 0) {
    toast.showToast('请阅读并同意投保须知和保险条款');
    return;
  }
  // 进度设置
  $('.claim-content .header-operation .progress #orderBtn2').addClass('btn-selected');
  $('.claim-content .header-operation .progress #orderBtn1').removeClass('btn-selected');
  // 
  $('.claim-content .header-operation .form-sheet').addClass('disabled');
  $('.claim-content .header-operation .form-sheet input').each(function () {
    $(this).attr('disabled', 'disabled');
  });
};

const onClickedUploadPic = (fileName, file) => {
  const _URL = window.URL || window.webkitURL;
  if (file && _URL) {
    const img = new Image();
    const src = _URL.createObjectURL(file);
    const picDOMText = '<img src="' + src + '" />';
    const domPath = '.claim-content .header-operation .form-sheet .row .content .pic-list';
    $(domPath).append(picDOMText);
  }
};

const init = () => {
  $('.borrow-content .header-operation .btn').on('click', function () {
    $('.apply-borrow-money').css('display', 'block');
  });
  $('.apply-borrow-money .apply-borrow-money-bk .content-panel .close').on('click', function () {
    $('.apply-borrow-money').css('display', 'none');
  });
  /*
  * 保险服务
  */
  // 点击 上传营业执照
  $('.claim-content .header-operation .form-sheet .row .content form #upload').on('change', function () {
    onClickedUploadPic(this.value, this.files && this.files.length > 0 && this.files[0]);
  });
  // 点击 条款 按钮
  $('.claim-content .header-operation .form-sheet .row .check-btn .icon').on('click', function () {
    if ($(this).hasClass('icon-selected')) {
      $(this).removeClass('icon-selected');
    } else {
      $(this).addClass('icon-selected');
    }
  });
  // 点击 提交 按钮
  $('.claim-content .header-operation .form-sheet .row .btn-submit').on('click', onClickedCommitClaim);
  /*
  * 农业补贴
  */
  // 点击 类型
  $('.allowance-content .header-operation .content .form-sheet .type .btn').each(function (index) {
    $(this).on('click', function () {
      // 之前选中的
      const iconPath = '.allowance-content .header-operation .content .form-sheet .type .btn-selected .icon';
      let iconImagePath = $(iconPath).attr('src');
      iconImagePath = iconImagePath.replace('-selected', '');
      $(iconPath).attr('src', iconImagePath);
      // 给现在选中的按钮 添加状态
      $(this).addClass('btn-selected').siblings().removeClass('btn-selected');
      iconImagePath = $(iconPath).attr('src');
      iconImagePath = iconImagePath.replace('.png', '-selected.png');
      $(iconPath).attr('src', iconImagePath);
    });
  });
  // 上传文件
  $('.allowance-content .header-operation .content .form-sheet form .file-list #upload').on('change', function () {
    const fileName = this.value && this.value.split('\\');
    if (fileName && fileName.length > 0) {
      appendFileItemToList(fileName[fileName.length - 1]);
    }
  });
  /*
  * 专家咨询
  */
  $('.expert-advice-content .header-operation .form-sheet .row .btn-submit').on('click', onClickedCommitAdvice);
};
module.exports = { init };
